export default {
  formId: 'jabatanForm',
  formField: {
    kode: {
      name: 'kode',
      label: 'Kode*',
      requiredErrorMsg: 'Kode harus diisi'
    },
    nama: {
      name: 'nama',
      label: 'Nama*',
      requiredErrorMsg: 'Nama harus diisi'
    },
    grup: {
      name: 'grup',
      label: 'Grup*',
      requiredErrorMsg: 'Grup harus diisi'
    }
  }
};
